export enum NotificationSeverity {
    INFO = 'INFO',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    CRITICAL = 'CRITICAL'
}
